import { gql } from '@apollo/client'
import { SURVEY_LINK_CONFIG_FIELDS } from './fragments/surveyLinkConfig'

export const SAVE_SURVEY_RESPONSES = gql`
  ${SURVEY_LINK_CONFIG_FIELDS}
  mutation saveSurveyResponses($surveyLinkId: ID!, $responses: [SurveyResponseItem!]!) {
    saveSurveyResponses(surveyLinkId: $surveyLinkId, responses: $responses) {
      responses {
        id
        surveyLink {
          config {
            ...SurveyLinkConfig
          }
        }
      }
    }
  }
`
